import { render } from "./ProcessComponentsIteratorV2.vue?vue&type=template&id=667cd394&scoped=true&ts=true"
import script from "./ProcessComponentsIteratorV2.vue?vue&type=script&lang=ts"
export * from "./ProcessComponentsIteratorV2.vue?vue&type=script&lang=ts"

import "./ProcessComponentsIteratorV2.vue?vue&type=style&index=0&id=667cd394&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667cd394"]])

export default __exports__